import React, {useEffect, useRef} from 'react';

const MinimalVideoPlayer = ({
	src,
	autoPlay = true,
	loop = true,
	muted = true,
}) => {
	const videoRef = useRef(null);

	useEffect(() => {
		if (videoRef.current) {
			if (autoPlay) {
				// Some browsers require explicit play() call even with autoPlay prop
				const playPromise = videoRef.current.play();

				if (playPromise !== undefined) {
					playPromise.catch(error => {
						console.log('Video autoplay failed:', error);
					});
				}
			}
		}
	}, [autoPlay]);

	return (
		<div className='relative w-full h-full'>
			<video
				ref={videoRef}
				className='w-full h-full object-cover'
				playsInline
				autoPlay={autoPlay}
				loop={loop}
				muted={muted}
			>
				<source src={src} type='video/mp4' />
				Your browser does not support the video tag.
			</video>
		</div>
	);
};

export default MinimalVideoPlayer;
